var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScrollMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 44,
  fill: "none",
  viewBox: "0 0 30 44"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B95B46",
  d: "M13.586 42.447a2 2 0 0 0 2.828 0L29.142 29.72a2 2 0 1 0-2.828-2.828L15 38.205 3.686 26.89A2 2 0 1 0 .858 29.72zM13 0v41.033h4V0z"
})));
export default SvgScrollMore;